<template>
  <Header></Header>
  <div id="impressum">
    <div class="container">
      <h1>Impressum</h1>
      <div>Gründer: Jakob Jentsch</div>
      <div>Wilsbergzeile 6a, 13465 Berlin</div>
      <div>hello@voiceart-productions.com</div>
      <div>+49 162 64 65 933</div>
      <div>USt-IdNr: DE 355 449 143</div>
    </div>
  </div>
</template>

<style scoped>
#impressum {
  padding-top: 3rem;
  background-color: black;
  color: white;
  height: 100vh;
}
</style>
